import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const SegmentRBAC = {
  pageID: '2a3f5b085b4ff78c11db5827d83809b0',
  elementID: {
    ViewSegment: '5e094e0d0a9e8deca7351c860a6b432e',
    ViewSegmentAB: '2231542c9e4f933538dcaddc60aa27bb',
    ViewSegmentGroup: 'a5db1535411186e5747a42915f8a6be7',
    CraeteSegment: 'e577d987f4e21981dffdb91d81f45a0f',
    CraeteSegmentGroup: '5222a31b78f16110329cd2aa58d9480c',
    EditSegment: '02db893f4710b5a96aa3858512e363ef',
    EditSegmentAB: '122b472e449bae75ee92f81609f97bde',
    EditSegmentGroup: 'ec86465f7b897000c91de0dded90846c',
    DeleteSegment: 'cf6e25aff3d47d92a5b6876edb075044',
    DeleteSegmentAB: '4ad1834a6cd3bd27f8d3865cf5b5ed5d',
    DeleteSegmentGroup: 'ac5299e8eddb2c1fc799180e2d2c762d',
    UpdateStatusSegment: '69524bc63281fb8c9d12d83f5fefafcc',
    UpdateStatusSegmentAB: '50d3c26f17f4e87d5d2b0be7ad01ec25',
    UpdateStatusSegmentGroup: 'b9d890f5b76e241a5f0f485b7885a4b5',
  },
} as const

export const useRBACSegmentPage = createUseRBAC(SegmentRBAC.elementID)

export type UseRBACSegmentPageType = ReturnType<typeof useRBACSegmentPage>
